import React from 'react';
import styled from 'styled-components';
import IconBtn from './IconBtn';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { loginAction, logoutAction } from '../../../modules/su/userModule';
import { clearUserCartAction } from '../../../modules/su/userCartModule';
import { resetItemStatus } from '../../../modules/es/esItemModule';

const HeaderMyBtnBlock = styled.div`
    display: inline-block;
    position: relative;
    margin-left: 15px;
    vertical-align: middle;
`;

const HeaderMyBtnSpanBlock = styled.span`
    position: absolute;
    top: 0px;
    right: -12px;
    padding: 0 6px;
    background-color: ${props => props.color};
    border-radius: 10px;
    font-size: 12px;
`;

const HeaderMyBtnBubbleBlock = styled.div`
    display: ${props => props.display};
    position: absolute;
    top: 50px;
    right: 0;
    min-width: 136px;
    padding: 15px 20px;
    background-color: #fff;
    border: 1px solid #ffc742;
    border-radius: 4px;

    ::before {
        content: "";
        display: block;
        position: absolute;
        top: -14px;
        right: 6px;
        width: 16px;
        height: 14px;
        background-image: url(${props => props.img || ''});
        background-position: center;
        background-repeat: no-repeat;
    }
`;

const HeaderMyBtnBubbleIdBlock = styled.div`
    display: ${props => props.display};
    margin-bottom: 15px;
    font-size: 14px;
    word-break: keep-all;
`;

const HeaderMyBtnBubbleUlBlock = styled.ul`
    color: #666;
    font-size: 14px;
`;

const HeaderMyBtnBubbleLiBlock = styled.li`
    line-height: 1.5;
    cursor: pointer;

    &:hover {
        color: #111;
        font-weight: 700;
        text-decoration: underline;
    }
`;

const HeaderMyBtn = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [isBubbleShow, setBubbleShow] = useState(false);
    const [nickname, setNickname] = useState(null);
    const [isBubbleEnter, setBubbleEnter] = useState(false);


    const { nick, accessToken } = useSelector(
        ({ userReducer }) => ({
            accessToken: userReducer.accessToken,
            nick: userReducer.nickname,
        })
    );

    const btnContainRef = useRef(null);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (btnContainRef.current && !btnContainRef.current.contains(event.target)) {
                setBubbleShow(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [btnContainRef]);

    useEffect(() => {

        if (nick != null && accessToken != null && nick.length > 0) {
            setNickname(nick);
        }
        if (accessToken === null && nickname !== null) {
            setNickname(null);
            setBubbleShow(false);
        }

    }, [accessToken, nick])

    const handleClick = () => {
        setBubbleShow(!isBubbleShow);
    };

    const handleLogout = () => {
        dispatch(logoutAction());
        dispatch(clearUserCartAction());
        dispatch(resetItemStatus());
        history.push('/');
    };

    //#2530 history back 위치 저장되어 있는 경우 처리
    const handleLogin = () => {
        return history.replace("/login",{ from: history.location })
    }

    const getSubMenu = () => {

        if (accessToken) {
            return (
                <HeaderMyBtnBubbleUlBlock>
                    <HeaderMyBtnBubbleLiBlock><Link to="/es">나의 견적</Link></HeaderMyBtnBubbleLiBlock>
                    <HeaderMyBtnBubbleLiBlock><Link to="/myclip">나의 클립북</Link></HeaderMyBtnBubbleLiBlock>
                    <HeaderMyBtnBubbleLiBlock><Link to="/mysetting">회원정보관리</Link></HeaderMyBtnBubbleLiBlock>
                    <HeaderMyBtnBubbleLiBlock><Link to="/myquestion">1:1문의내역</Link></HeaderMyBtnBubbleLiBlock>
                    <HeaderMyBtnBubbleLiBlock onClick={handleLogout}>
                        로그아웃
                    </HeaderMyBtnBubbleLiBlock>
                </HeaderMyBtnBubbleUlBlock>

            );
        } else {
            return (
                <HeaderMyBtnBubbleUlBlock>
                    <HeaderMyBtnBubbleLiBlock onClick = {handleLogin}>
                        <a>로그인</a>
                    </HeaderMyBtnBubbleLiBlock>
                    <HeaderMyBtnBubbleLiBlock>
                        <Link to="/register">회원가입</Link>
                    </HeaderMyBtnBubbleLiBlock>
                </HeaderMyBtnBubbleUlBlock>
            );
        }

    }


    return (
        <HeaderMyBtnBlock ref={btnContainRef}>
            <IconBtn
                img={accessToken ? "/assets/images/icon/mypage-icon-on.png" : "/assets/images/icon/mypage-icon-off.png"}
                onClick={handleClick} marginTop={'5px'}/>
            <HeaderMyBtnSpanBlock color={accessToken ? '#79b88a' : '#999'}>
                {accessToken ? 'ON' : 'OFF'}
            </HeaderMyBtnSpanBlock>
            <HeaderMyBtnBubbleBlock
                display={isBubbleShow ? 'block' : 'none'}
                img="/assets/images/icon/bubble_arrow-icon.png">
                <HeaderMyBtnBubbleIdBlock display={accessToken ? 'block' : 'none'}>
                    {nickname}
                </HeaderMyBtnBubbleIdBlock>
                {getSubMenu()}
            </HeaderMyBtnBubbleBlock>
        </HeaderMyBtnBlock>
    );
};

export default HeaderMyBtn;